<form [formGroup]="supportForm" (ngSubmit)="onSubmitSupportForm()">
    <div class="form-control">
        <label>{{ 'NAV.HEADERS.MODAL.SUPPORT.BUG_DESCRIPTION' | translate }}</label>
        <textarea formControlName="bug_description" name="bug_desc" id="bug_desc" cols="30" rows="4"></textarea>
    </div>
    <div class="form-control">
        <label>{{ 'NAV.HEADERS.MODAL.SUPPORT.ESPECTED_BEHAVIOR' | translate }}</label>
        <textarea formControlName="normal_behavior" name="behavior" id="behavior" cols="30" rows="8"></textarea>
    </div>

    <app-generic-button
        [classes]="'btn--primary'"
        [inputText]="'NAV.HEADERS.MODAL.SUPPORT.BUTTON_SEND'"
        [type]="'submit'"
    ></app-generic-button>
</form>
